import variants from './variants'
import { submitFile2SAS } from '@/services/httpClientHelper.js'

const population = {
  namespaced: true,
  state: () => ({
    // Report related
    productType: null,
    populationType: null,
    assemblyPeriodSelector: {
      assemblyPeriodFrom: '',
      assemblyPeriodTo: '',
      assemblyPeriodValid: false,
      includeTestVehicles: false,
      includeOptOutProducts:false,
      onlyChassisWithDeliveryDate: false
    },
    validateAssemblyPeriod: {
      assemblyPeriodFrom: false,
      assemblyPeriodTo: false
    },
    chassisNumbers: '',
    chassisFiles: [],
    // GUI
    showProductTypeSwitchModal: false
  }),
  mutations: {
    productType (state, value) {
      state.productType = value
    },
    populationType (state, value) {
      state.populationType = value
    },
    setAssemblyPeriodSelectorData (state, value) {
      state.assemblyPeriodSelector = { ...state.assemblyPeriodSelector, ...value }
    },
    setChassisNumbers (state, value) {
      state.chassisNumbers = value
    },
    setChassisFiles (state, value) {
      state.chassisFiles = value
    },
    reset (state) {
      state.populationType = null
      state.productType = null
      state.assemblyPeriodSelector = {
        assemblyPeriodFrom: '',
        assemblyPeriodTo: '',
        assemblyPeriodValid: false,
        includeTestVehicles: false,
        includeOptOutProducts:false,
        onlyChassisWithDeliveryDate: false
      }
      state.validateAssemblyPeriod = {
        assemblyPeriodFrom: false,
        assemblyPeriodTo: false
      }
      state.chassisNumbers = ''
      state.chassisFiles = []
    },
    showProductTypeSwitchModal (state, value) {
      state.showProductTypeSwitchModal = value
    }
  },
  getters: {
    getProductType: state => { return state.productType },
    isSelectionValid: (state, getters) => {
      return state.productType &&
      (
        state.assemblyPeriodSelector.assemblyPeriodValid ||
        getters['variants/getFamilyExecutionsReportFormatted'].length > 0 ||
        // getters['variants/getCscCodesReportFormatted'].length > 0 ||
        (state.chassisNumbers.length > 0 || state.chassisFiles.length > 0)
      )
    },
    isSelectionValidForDiagramsReports: (state) => {
      return (state.chassisNumbers.length > 0 || state.chassisFiles.length > 0)
    },
    getChassiNumbersReportFormatted: state => {
      // let allFileChassiNumbers = ''
      // for (const file of state.chassisFileData) {
      //   allFileChassiNumbers += (file.content.slice(-1) !== ',') ? file.content + ',' : file.content
      // }

      // return allFileChassiNumbers + state.chassisNumbers
      return state.chassisNumbers
    },
    getAllSelectionsReportFormatted: (state, getters) => {
      return {
        productType: state.productType,
        fpcCodes: getters['variants/getFamilyExecutionsReportFormatted'],
        cscCodes: getters['variants/getCscCodesReportFormatted'],
        chassiList: getters.getChassiNumbersReportFormatted,
        chassiFiles: state.chassisFiles.map(file => file.fileId),
        assemblagePeriodFrom: state.assemblyPeriodSelector.assemblyPeriodFrom,
        assemblagePeriodTo: state.assemblyPeriodSelector.assemblyPeriodTo,
        preSerie: state.assemblyPeriodSelector.includeTestVehicles,
        optOutProducts: state.assemblyPeriodSelector.includeOptOutProducts,
        onlyDeliveryDate: state.assemblyPeriodSelector.onlyChassisWithDeliveryDate
      }
    },
    getAllSelections: (state, getters) => {
      return {
        variants: getters['variants/getAllSelections'],
        productType: state.productType,
        populationType: state.populationType,
        assemblyPeriodSelector: state.assemblyPeriodSelector,
        chassisNumbers: state.chassisNumbers
      }
    }
  },
  actions: {
    async uploadFiles ({ commit, state }) {
      if (state.chassisFiles.length === 0) return
      const fileArray = []
      return await Promise.all(state.chassisFiles.map(async (fileObj) => {
        if (!fileObj.file) {
          fileArray.push(fileObj)
          return
        }
        const data = await submitFile2SAS(fileObj.file)
        if (!data.fileId) {
          fileArray.push(fileObj)
          return
        }
        fileArray.push({
          name: fileObj.name,
          fileId: data.fileId
        })
        if (!data) {
          // FileUploadError!
          console.log('Error uploading csv file to SAS...')
        }
        commit('setChassisFiles', fileArray)
      }))
    },
    loadStateFromFile ({ commit, dispatch }, data) {
      commit('productType', data.productType)
      dispatch('setPopulationType', data.populationType)

      // Ajusting variants
      const newVariantsFamilies = data.variants.families.map((element) => {
        if(element.toString().length < 5 &&  data.productType?.name !== 'NAVISTAR'){
          return '0' + element
        }
        else return element
      })
      const newVariantsFamilyExecutions = data.variants.familyExecutions.map((element) => {

        if((element.split(':')[0]).toString().length < 5 &&  data.productType?.name !== 'NAVISTAR'){
          return '0' + element
        }
        else return element
      })

      const mappingVariant = {families: newVariantsFamilies, familyExecutions: newVariantsFamilyExecutions}
      dispatch('variants/loadStateFromFile', mappingVariant)

      commit('setAssemblyPeriodSelectorData', data.assemblyPeriodSelector)
      commit('setChassisNumbers', data.chassisNumbers)
    },
    setProductType: ({ commit, state, dispatch, getters, rootState }, value) => {
      if (state.productType === null) {
        commit('productType', value)
      } 
      else if ((!getters['variants/isSelected'] && rootState.selectedReport === null)) {
        commit('productType', value)
        if (state.populationType === 'VARIANT') {
          dispatch('variants/getFamilies', state.populationType)
        }
      } else {
        if(state.productType !== value){
          commit('productType', value)
          //Triggering change modal product type if product type has changed
          commit('showProductTypeSwitchModal', true)
        }
      }
      commit('variants/familiesLoadingError', false)
      commit('variants/familyExecutionsLoadingError', false)
    },
    setPopulationType ({ dispatch, commit, state }, value) {
      commit('populationType', value)
      if (state.populationType === 'VARIANT') {
        dispatch('variants/getFamilies', state.populationType)
      }
    },
    resetSelections: ({ commit }) => {
      commit('reset')
      commit('variants/resetSelected')
      commit('setSelectedReportType', null, { root: true })
    },
    reset: ({ commit }) => {
      commit('reset')
      commit('variants/reset')
      commit('setSelectedReportType', null, { root: true })
    }
  },
  modules: {
    variants: variants
  }
}
export default population
